export const STORY_GRAPH_ISSUE_CODE_VALUES = [
    "entry_node_missing",
    "entry_node_has_parent",
    "node_unreachable",
    "graph_cycle",
    "node_outcome_conflict",
    "node_without_shots",
    "node_reference_invalid",
    "ending_reference_invalid",
    "shot_node_invalid",
    "duplicate_node_id",
    "duplicate_shot_id",
    "duplicate_ending_id",
    "duplicate_flag_name",
    "duplicate_choice_id",
    "convergence_strategy_required",
    "convergence_first_shot_not_canonical",
    "inherit_tail_without_source",
    "shot_duration_invalid",
    "shot_video_duration_invalid",
    "decision_choice_count_invalid",
    "decision_default_choice_invalid",
    "decision_timeout_invalid",
    "flag_undeclared",
    "flag_effect_invalid",
    "flag_condition_invalid",
    "ending_unresolvable",
    "default_rule_missing",
    "default_rule_duplicate",
    "default_rule_not_lowest_priority",
    "rule_priority_duplicate",
];
export const StoryGraphIssueCode = {
    ENTRY_NODE_MISSING: "entry_node_missing",
    ENTRY_NODE_HAS_PARENT: "entry_node_has_parent",
    NODE_UNREACHABLE: "node_unreachable",
    GRAPH_CYCLE: "graph_cycle",
    NODE_OUTCOME_CONFLICT: "node_outcome_conflict",
    NODE_WITHOUT_SHOTS: "node_without_shots",
    NODE_REFERENCE_INVALID: "node_reference_invalid",
    ENDING_REFERENCE_INVALID: "ending_reference_invalid",
    SHOT_NODE_INVALID: "shot_node_invalid",
    DUPLICATE_NODE_ID: "duplicate_node_id",
    DUPLICATE_SHOT_ID: "duplicate_shot_id",
    DUPLICATE_ENDING_ID: "duplicate_ending_id",
    DUPLICATE_FLAG_NAME: "duplicate_flag_name",
    DUPLICATE_CHOICE_ID: "duplicate_choice_id",
    CONVERGENCE_STRATEGY_REQUIRED: "convergence_strategy_required",
    CONVERGENCE_FIRST_SHOT_NOT_CANONICAL: "convergence_first_shot_not_canonical",
    INHERIT_TAIL_WITHOUT_SOURCE: "inherit_tail_without_source",
    SHOT_DURATION_INVALID: "shot_duration_invalid",
    SHOT_VIDEO_DURATION_INVALID: "shot_video_duration_invalid",
    DECISION_CHOICE_COUNT_INVALID: "decision_choice_count_invalid",
    DECISION_DEFAULT_CHOICE_INVALID: "decision_default_choice_invalid",
    DECISION_TIMEOUT_INVALID: "decision_timeout_invalid",
    FLAG_UNDECLARED: "flag_undeclared",
    FLAG_EFFECT_INVALID: "flag_effect_invalid",
    FLAG_CONDITION_INVALID: "flag_condition_invalid",
    ENDING_UNRESOLVABLE: "ending_unresolvable",
    DEFAULT_RULE_MISSING: "default_rule_missing",
    DEFAULT_RULE_DUPLICATE: "default_rule_duplicate",
    DEFAULT_RULE_NOT_LOWEST_PRIORITY: "default_rule_not_lowest_priority",
    RULE_PRIORITY_DUPLICATE: "rule_priority_duplicate",
};
